/* eslint-disable no-loop-func */
import { useEffect, useRef } from 'react';
import mapboxgl from 'mapbox-gl';
import { DataModelV2, ICompetingOrFutureClub } from './data';
import * as turf from '@turf/turf';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';

export const TeamMap: React.FC = () => {
    const markerContainerRef = useRef<HTMLDivElement>(null);
    const data = useInstance(DataModelV2);
    useSubscription(() => data);

    useEffect(() => {

        const allClubs = data.getCompetingAndFutureClubs();
        let relevantSchools = allClubs.filter(c => c.status === 'status-competing');

        mapboxgl.accessToken = 'pk.eyJ1IjoiamhvZ3VldC1uZWxzb24tb2Zmcm9hZCIsImEiOiJjbTFycmgyOTUwM2poMmxvcWhibTZkbzFiIn0.PwTn7gglDhycDCPOzHRyaw';
        const map = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/mapbox/streets-v11',
            dragPan: false,
            doubleClickZoom: false,
            dragRotate: false,
            scrollZoom: false,
            touchPitch: false,
            touchZoomRotate: false,
        });
        document.querySelector('#map')!.classList.add('active-only');

        let userSelectedAMarker = false;

        let lastFocusedIndex = relevantSchools.length - 1;

        const hideSchoolCard = () => {
            document.querySelector('#mini-map-school-card')!.classList.remove('show');
        }

        const defaultMessages = {
            'volunteerStatus': {
                'healthy': 'Healthy continuity in volunteers looking out at least the next 2 years',
                'caution': 'Have enough volunteers to continue to function this year, but concenred about continuity looking out to next year',
                'danger': 'Need to find volunteers to get the program started.'
            },
            fundingStatus: {
                'healthy': 'Have enough funding to sustain the program for at least the next 2 years',
                'caution': 'Have enough funding for this year, but still working on next year',
                'danger': 'Need to find funding to get the program started.'
            },
            locationStatus: {
                'healthy': 'Have a robotics lab for at least the next 2 years.',
                'caution': `Have a space but it is barely adeqaute, or don't have a space for next year.`,
                'danger': `Need to find space to get the program started.`
            }

            // volunteer status
            //     - danger - don't have enough volunteers to have a program this year
            //     - caution - have enough volunteers to have a program  this year, but
            //                     risk that there won't be enough next year
            //     - healthy  - have at least 2 volunteers, and at least one committed to next year
            // funding status
            //     - danger - don't have enough $$ to have a program this year
            //     - caution - have enough for this year, but not next year
            //     - healthy  - have enough money for this year and next year
            // location status
            //     - danger - can't meet b/c we don't have a space
            //     - caution - have a space but it is inadeqaute, or the don't have a space for next year
            //     - healthy  - have an adequate space for this year and next year
        }

        const showSchoolCard = (school: ICompetingOrFutureClub) => {
            const club = data.getCompetingAndFutureClubs().find(c => c.clubId === school.clubId);
            if (!club){
                return;
            }

            // get the latest data
            document.querySelector('#mini-map-school-card')!.classList.add('show');

            document.querySelector('#mini-map-school-card h1')!.innerHTML = club.name;

            const volunteerEl = document.querySelector('#mini-map-school-card .fa-child-reaching')!;
            volunteerEl.classList.remove('danger', 'caution', 'healthy');
            const volunteerStatus = club.health.volunteerStatus || 'danger';
            volunteerEl.classList.add(volunteerStatus);
            const volunteerStatusMessage = club.health.volunteerStatusMessage || defaultMessages['volunteerStatus'][volunteerStatus];
            document.querySelector('#mini-map-school-card .volunteer-health span')!.innerHTML = volunteerStatusMessage;
            // TODO: volunteer sign up form

            const fundingEl = document.querySelector('#mini-map-school-card .fa-hand-holding-dollar')!;
            fundingEl.classList.remove('danger', 'caution', 'healthy');
            const fundingStatus = club.health.fundingStatus || 'danger';
            fundingEl.classList.add(fundingStatus);
            const fundingStatusMessage = club.health.fundingStatusMessage || defaultMessages.fundingStatus[fundingStatus];
            document.querySelector('#mini-map-school-card .funding-health span')!.innerHTML = fundingStatusMessage;
            // TODO: link to funding

            const locationEl = document.querySelector('#mini-map-school-card .fa-building-flag')!;
            locationEl.classList.remove('danger', 'caution', 'healthy');
            const locationStatus = club.health.labStatus || 'danger';
            locationEl.classList.add(locationStatus);
            const locationStatusMessage = club.health.labStatusMessage || defaultMessages.locationStatus[locationStatus];
            document.querySelector('#mini-map-school-card .location-health span')!.innerHTML = locationStatusMessage;
            // TODO: link to help us find a better space

            const status = club.status;

            if (status === 'status-forming') {
                const queryParams = new URLSearchParams();

                queryParams.set('usp', 'pp_url')
                queryParams.set('entry.2060967528', club.name)

                const formUrl = `https://docs.google.com/forms/d/e/1FAIpQLSf5zP2jkF88Trdu2gtP2QDGwuqvWCMPurAm2lLYXQEhGz7RcQ/viewform?${queryParams.toString()}`;

                document.querySelector('#mini-map-school-card .cta-row')!.innerHTML = `
                            <a class="btn btn-custom" href="${formUrl}" target="_blank">Start the Team</a>
                            <givebutter-widget id="LWoKQL"></givebutter-widget>
                        `;
                // TODO: they might have an active campaign!?
            }
            else {
                document.querySelector('#mini-map-school-card .cta-row')!.innerHTML = ``;

                const queryParams = new URLSearchParams();

                queryParams.set('usp', 'pp_url')
                queryParams.set('entry.2060967528', club.name)

                const formUrl = `https://docs.google.com/forms/d/e/1FAIpQLSehG5x8-So9XU3sSwUk-ijBH8ZrJxpL88EN8-0tFd13qEsR8g/viewform?${queryParams.toString()}`;
                const volunteerButton = document.createElement('a');
                volunteerButton.classList.add('btn', 'btn-custom');
                volunteerButton.href = formUrl;
                volunteerButton.target = '_blank';
                volunteerButton.innerHTML = 'Volunteer'
                document.querySelector('#mini-map-school-card .cta-row')!.appendChild(volunteerButton);

                const campaign = data.getFundingCampaignForClub(club.clubId);
                if (campaign && campaign.buttonWidgetId) {
                    const donationButton = document.createElement('givebutter-widget');
                    donationButton.setAttribute('id', campaign.buttonWidgetId);
                    document.querySelector('#mini-map-school-card .cta-row')!.appendChild(donationButton);
                }
                else if (club.donationLink) {
                    const donationButton = document.createElement('a');
                    donationButton.classList.add('btn', 'btn-custom', 'emulate-give-butter-button');
                    donationButton.href = club.donationLink;
                    donationButton.target = '_blank';
                    donationButton.innerHTML = `<i class="fa fa-hand-holding-dollar"></i> Donate`;
                    document.querySelector('#mini-map-school-card .cta-row')!.appendChild(donationButton);
                }
            }

        }

        for (const school of allClubs) {
            let marker: mapboxgl.Marker;

            const addMarker = () => {
                // this isn't working because mapbox is "claiming the dom element"
                const reactMarkerElement = markerContainerRef.current!.querySelector(`[data-club-id="${school.clubId}"]`)!;
                if (!reactMarkerElement){
                    throw new Error(`missing marker for club ${school.clubId}`);
                }
                const markerElement = reactMarkerElement.cloneNode(true) as Element;

                marker = new mapboxgl.Marker(markerElement)
                    .setLngLat(school.coordinate)
                    .addTo(map);

                markerElement.addEventListener('click', (e) => {
                    // stop propogation so that it isn't seen as a map click
                    e.stopImmediatePropagation();

                    // stop auto looping through markers
                    userSelectedAMarker = true;

                    // remove the focus from last selected marker
                    (relevantSchools[lastFocusedIndex] as any).marker.getElement().classList.remove('focused-marker');

                    marker.remove()

                    addMarker();

                    lastFocusedIndex = relevantSchools.indexOf(school);

                    (relevantSchools[lastFocusedIndex] as any).marker.getElement().classList.add('focused-marker');

                    showSchoolCard(relevantSchools[lastFocusedIndex]);
                });

                (school as any).marker = marker;
            }

            (school as any).addMarker = addMarker;

            addMarker();
        }

        const fitSchools = (relevantSchools: ICompetingOrFutureClub[]) => {
            const points = relevantSchools.map(s => turf.point(s.coordinate));
            const bbox = turf.bbox({
                type: 'FeatureCollection',
                features: points
            });
            map.fitBounds(bbox as any, { padding: { top: 90, bottom: 75, left: 75, right: 75 } });
        }

        const mapEl = document.querySelector('#map')!;

        fitSchools(relevantSchools);

        const activeOnlyButton = document.querySelector('#active-only')!;
        const inactiveOnlyButton = document.querySelector('#inactive-only')!;

        inactiveOnlyButton.classList.add('btn-custom-inverse');

        activeOnlyButton.addEventListener('click', () => {
            mapEl.classList.remove('inactive-only');
            mapEl.classList.add('active-only');
            relevantSchools = allClubs.filter(school => school.status === 'status-competing');
            fitSchools(relevantSchools);
            activeOnlyButton.classList.remove('btn-custom-inverse');
            inactiveOnlyButton.classList.add('btn-custom-inverse');

            userSelectedAMarker = false;
            lastFocusedIndex = relevantSchools.length - 1;

            hideSchoolCard();
        });
        inactiveOnlyButton.addEventListener('click', () => {

            mapEl.classList.add('inactive-only');
            mapEl.classList.remove('active-only');
            relevantSchools = allClubs.filter(school => school.status === 'status-forming');
            fitSchools(relevantSchools);
            activeOnlyButton.classList.add('btn-custom-inverse');
            inactiveOnlyButton.classList.remove('btn-custom-inverse');

            userSelectedAMarker = false;
            lastFocusedIndex = relevantSchools.length - 1;
            hideSchoolCard();
        });

        const intervalId = setInterval(() => {
            if (!userSelectedAMarker) {
                (relevantSchools[lastFocusedIndex] as any).marker.getElement().classList.remove('focused-marker');

                lastFocusedIndex = lastFocusedIndex + 1;
                if (lastFocusedIndex >= relevantSchools.length) {
                    lastFocusedIndex = 0;
                }
                const focusOnSchool = relevantSchools[lastFocusedIndex] as any;
                focusOnSchool.marker.remove();
                focusOnSchool.addMarker();

                focusOnSchool.marker.getElement().classList.add('focused-marker');
            }
        }, 1500);

        map.on('click', () => {
            hideSchoolCard();
        });

        const unsub = data.subscribe(() => {
            // wait long enough for the dom change to take effect
            setTimeout(() => {
                for (const club of allClubs){
                    (club as any).marker.remove();
                    (club as any).addMarker();
                }
            },10);
        });

        return () => {
            clearInterval(intervalId);
            unsub();
        }
    }, [])
    return (
        <>
            <div id="teams"></div>
            <div style={{ position: 'relative' }}>
                <div id="map" className="preview-mode"></div>
                <div id="mini-map-filters">
                    <a className="btn btn-custom" id="active-only">
                        Competing Teams
                    </a>
                    <a className="btn btn-custom" id="inactive-only">
                        Future Teams!
                    </a>
                </div>
                <div id="map-footer">
                    <div id="mini-map-legend">
                        <div>
                            <div><i className="fa fa-child-reaching healthy"></i> Volunteer Health</div>
                            <div><i className="fa fa-hand-holding-dollar healthy"></i> Funding Health</div>
                            <div><i className="fa fa-building-flag healthy"></i> Robotics Lab Health</div>
                        </div>
                        <div>
                            <div><i className="fa fa-child-reaching danger"></i> This year is at risk</div>
                            <div><i className="fa fa-child-reaching caution"></i> Next year is at risk</div>
                            <div><i className="fa fa-child-reaching healthy"></i> Healthy Continuity</div>
                        </div>
                        <div>(click on each team to learn more)</div>
                    </div>
                    <div id="mini-map-school-card">
                        <div>
                            <h1></h1>
                            <div className="volunteer-health"><i className="fa fa-child-reaching"></i><span></span></div>
                            <div className="funding-health"><i className="fa fa-hand-holding-dollar"></i> <span></span></div>
                            <div className="location-health"><i className="fa fa-building-flag"></i> <span></span></div>
                            <div className="cta-row"></div>
                        </div>
                    </div>
                </div>
                <div id="map-legend">
                    <h1>Legend</h1>
                    <section>
                        <h1>Volunteers</h1>
                        <div><i className="fa fa-child-reaching danger"></i></div>
                        <div><i className="fa fa-child-reaching caution"></i></div>
                        <div><i className="fa fa-child-reaching healthy"></i></div>
                    </section>
                    <section>
                        <h1>Funding</h1>
                        <div><i className="fa fa-hand-holding-dollar danger"></i></div>
                        <div><i className="fa fa-hand-holding-dollar caution"></i></div>
                        <div><i className="fa fa-hand-holding-dollar healthy"></i></div>
                    </section>
                    <section>
                        <h1>Location</h1>
                        <div><i className="fa fa-building-flag danger"></i></div>
                        <div><i className="fa fa-building-flag caution"></i></div>
                        <div><i className="fa fa-building-flag healthy"></i></div>
                    </section>

                </div>
                <div ref={markerContainerRef} style={{ display: 'none'}}>
                    {data.getCompetingAndFutureClubs().map(c => (
                        <div key={c.clubId} data-club-id={c.clubId} className={`school-marker ${c.status}`} >
                            <h1>{c.name}</h1>
                            <div className="logo-container">
                                <i className={`fa fa-child-reaching volunteer-status ${c.health.volunteerStatus || 'danger'} `} />
                                <i className={`fa fa-hand-holding-dollar ${c.health.fundingStatus || 'danger'}`} />
                                <i className={`fa fa-building-flag ${c.health.labStatus || 'danger'}`} />
                                <img className="vex"
                                    src="./images/vex/vex-robotics-logo.png"
                                    style={{ display: c.teams.some(t => t.teamType === 'vex') ? 'inline-block' : 'none'}}
                                />
                                <img
                                    className="first"
                                    src="./images/first/first-logo.jpg"
                                    style={{ display: c.teams.some(t => ['frc', 'ftc'].includes(t.teamType)) ? 'inline-block' : 'none' }}
                                />
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </>
    );
}
